import { Box, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import bannerImage from "../../assets/gallery-8.jpg";

const Banner = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: "200px", md: "300px" },
        backgroundImage: `url(${bannerImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.7)", // Полупрозрачный темный наложение
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          padding: { xs: "0 10px", md: "0 20px" },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "1.5rem", md: "2.5rem" },
            marginTop: isMobile ? "30px" : "0",
          }}
        >
          CLIENT TESTIMONIALS
        </Typography>
        <Typography
          variant="h6"
          sx={{ mt: 2, fontSize: { xs: "1rem", md: "1.25rem" } }}
        >
          We see every project as an opportunity to build a lasting
          relationship.
        </Typography>
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: { xs: "10px", md: "20px" },
          right: { xs: "10px", md: "20px" },
          textAlign: "right",
          zIndex: 2,
        }}
      >
        <Typography
          variant="body1"
          sx={{ fontSize: { xs: "0.75rem", md: "1rem" } }}
        >
          ASK AN EXPERT
        </Typography>
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", fontSize: { xs: "1.5rem", md: "2rem" } }}
        >
          (312) 636-1186
        </Typography>
      </Box>
    </Box>
  );
};

export default Banner;
